import { render } from "./ContactRequests.vue?vue&type=template&id=9d5bbcae&scoped=true"
import script from "./ContactRequests.vue?vue&type=script&lang=js"
export * from "./ContactRequests.vue?vue&type=script&lang=js"

import "./ContactRequests.vue?vue&type=style&index=0&id=9d5bbcae&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d5bbcae"]])

export default __exports__